import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, from, map } from 'rxjs';
import { Auth } from '@aws-amplify/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  return from(Auth.currentAuthenticatedUser()).pipe(
    map((session: unknown) => {
      if (session) {
        return true;
      } else {
        router.navigate(['/public']);
        return false;
      }
    }),
    catchError((error) => {
      console.log('Error fetching session:', error);
      router.navigate(['/public']); // Redirect to login on error
      return from([false]); // Deny access if an error occurs
    }),
  );
};
